export enum OrderStatusEnum {
  CertificateSent = 'CertificateSent', // נשלחה תעודה להמשך טיפול המשרד
  Closed = 'Closed', // סיום ביצוע
  HandledByLimor = 'HandledByLimor', // בטיפול לימור - חריגים
  InspectionInProgress = 'InspectionInProgress', // בבדיקה-קיימות תכניות
  InspectionInProgressNoPlans = 'InspectionInProgressNoPlans', // בבדיקה-ללא תכניות
  InspectionInProgressPartialPlans = 'InspectionInProgressPartialPlans', // בבדיקה-קיימות תכניות חלקיות
  InvoiceSentWithoutCertificate = 'InvoiceSentWithoutCertificate', // חשבונית נשלחה לתשלום - טרם נשלחה תעודה
  New = 'New', // חדש
  SendCertificateAfterAproval = 'SendCertificateAfterAproval', // לשחרר תעודה/חן לאחר קבלת אישור הצעת מחיר/רכש
  WaitingForCustomerDocs = 'WaitingForCustomerDocs', // הוחזר לבודק- ממתין למסמך מהלקוח/ תיקון תעודה
  WaitingForInspection = 'WaitingForInspection', // ממתין לבדיקה
  WaitingForYarivApproval = 'WaitingForYarivApproval', // תעודה לאישור אצל יריב
  WaitingForAkivaApproval = 'WaitingForAkivaApproval', // תעודה לאישור אצל עקיבא
  WaitingForRoiApproval = 'WaitingForRoiApproval', // תעודה לאישור אצל רועי
  WaitingForSchedulingInspection = 'WaitingForSchedulingInspection', // לקוח ייצור קשר לתיאום הבדיקה
  ReadyForSchedulingInspection = 'ReadyForSchedulingInspection', // ממתין לתיאום בדיקה (ראה הערות)
  Old = 'Old', // הועבר מיעף - טרם אושר
  FixingOrder = 'FixingOrder', // יצירת תעודה מתקנת
  WaitingForReview = 'WaitingForReview' // ממתין לאישור בודק שני (Order.reviewedBy)
}
